/* global playTimeApiUrl, Hls */
let playTimeApiErrorCount = 0
const PLAY_TIME_API_MAX_ERRORS = 3

function getHlsResponseStatus(data) {
  const response = (data && data.response) || {}
  return Number(response.code ?? response.status)
}

function isHlsRequestCancelled(data) {
  if (!data) {
    return true
  }
  if (data.aborted) {
    return true
  }
  const details = String(data.details || '').toLowerCase()
  if (details.includes('abort')) {
    return true
  }
  const err = data.error
  if (err) {
    const name = String(err.name || '')
    const message = String(err.message || '').toLowerCase()
    if (name === 'AbortError' || message.includes('abort') || message.includes('cancel')) {
      return true
    }
  }
  // シーク等でキャンセルされた XHR は status 0 になる
  return getHlsResponseStatus(data) === 0
}

function shouldCountHlsNetworkError(data) {
  if (!data) {
    return false
  }
  const isNetworkError =
    data.type === (Hls.ErrorTypes && Hls.ErrorTypes.NETWORK_ERROR) || data.type === 'networkError'
  if (!isNetworkError) {
    return false
  }
  if (isHlsRequestCancelled(data)) {
    return false
  }
  if (data.fatal) {
    return true
  }
  const status = getHlsResponseStatus(data)
  // HLS.js が自己回復する非fatalは除外。実HTTPエラー（4xx/5xx）のみカウント
  return status >= 400 && status < 600
}
// import videojs from 'video.js'
// import 'videojs-vtt-thumbnails' // サムネイルプラグイン
// import 'videojs-contrib-quality-levels' // 画質選択プラグイン
// import 'videojs-hls-quality-selector' // 画質選択プラグイン

import scrollLock from './functions/_scrollLock.js' // スクロールロック
import getCookie from './functions/_cookie-getCookie.js' // Cookie取得
import setCookie from './functions/_cookie-setCookie.js' // Cookie発行

import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
import isDevice from './functions/_isDevice.js'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
if (document.getElementsByClassName('js-video')[0]) {
  videoPlayer()
}
// ボタンをクリックしたらフォーカスを外す
window.addEventListener('click', function (e) {
  const item = e.target.closest('button')
  if (!item) {
    return
  }
  document.activeElement.blur()
})

function videoPlayer() {
  const deviceOS = isDeviceOS()

  const player = []

  const videoList = document.getElementsByClassName('js-video')
  let videoID = 0
  for (const videoItem of videoList) {
    // ラップ用クラスで覆う
    videoItem.outerHTML = '<div class="videoFrame">' + videoItem.outerHTML + '</div>'
  }
  for (const videoItem of videoList) {
    ++videoID
    videoItem.classList.add('video-' + videoID) // 識別用IDを付ける
    videoItem.dataset.videoId = videoID // 制御用IDを付ける

    // 動画を起動
    videoSetup(videoItem, videoID)
  }

  //   ####  #####  ######  ##   ##  #####
  //  ##     ##       ##    ##   ##  ##  ##
  //   ###   #####    ##    ##   ##  #####
  //     ##  ##       ##    ##   ##  ##
  //  ####   #####    ##     #####   ##

  function videoSetup(videoItem, videoID) {
    //  ##      ##  #####      ###    #####
    //  ##      ##  ##  ##    ## ##   ##  ##
    //  ##  ##  ##  #####    ##   ##  #####
    //  ##  ##  ##  ##  ##   #######  ##
    //   ###  ###   ##   ##  ##   ##  ##
    // 動画要素を決まったタグでラップする
    // 出力する操作ボタン
    let control = [
      { name: 'progressControl' },
      { name: 'playToggle' },
      { name: 'volumePanel', inline: true },
      { name: 'currentTimeDisplay' },
      { name: 'TimeDivider' },
      { name: 'durationDisplay' },
      { name: 'spacer' },
    ]
    if (deviceOS !== 'android') {
      // Android以外はピクチャーインピクチャーボタンを追加
      control.push({ name: 'pictureInPictureToggle' })
    }
    control.push({ name: 'FullscreenToggle' })
    const videoUrl = videoItem.dataset.video

    let playlistRetryCount = 0
    const MAX_PLAYLIST_RETRIES = 10

    player[videoID] = videojs(videoItem, {
      controls: true,
      fluid: true,
      autoplay: false,
      preload: 'none',
      controlBar: {
        children: control,
        volumePanel: { inline: false },
      },
      html5: {
        hls: {
          overrideNative: true,
        },
        vhs: {
          maxPlaylistRetries: 10,
          blacklistDuration: 30,
        },
        nativeAudioTracks: false,
        nativeVideoTracks: false,
      },
    })

    player[videoID].on('loadedmetadata', function () {
      playlistRetryCount = 0
    })
    player[videoID].on('playing', function () {
      playlistRetryCount = 0
    })
    player[videoID].on('loadstart', function () {
      if (player[videoID].tech_ && player[videoID].tech_.vhs && !player[videoID].tech_.retryPlaylistListenerSet) {
        player[videoID].tech_.retryPlaylistListenerSet = true
        player[videoID].tech_.on('retryplaylist', function () {
          playlistRetryCount++
          if (playlistRetryCount > MAX_PLAYLIST_RETRIES) {
            player[videoID].pause()
            player[videoID].error({ code: 4, message: '再生エラーが繰り返し発生したため停止しました' })
          }
        })
      }
    })
    player[videoID].on(['error'], function () {
      const error = player[videoID].error()
      if (error && error.code === 4) {
        const message = (error.message || '').toLowerCase()
        if (
          message.includes('403') ||
          message.includes('401') ||
          message.includes('forbidden') ||
          message.includes('session not accepted')
        ) {
          player[videoID].pause()
        }
      }
    })

    //解像度をを追加
    function addQualityMenu(videoElement, player, hls) {
      let qualitySelector = videoElement.parentNode.querySelector('.vjs-quality-selector')
      if (!qualitySelector) {
        console.warn(`.vjs-quality-selector not found for video ${videoElement.id}, creating manually`)
        qualitySelector = document.createElement('div')
        qualitySelector.className = `video-${videoElement.id} vjs-menu-button vjs-menu-button-popup vjs-control vjs-button vjs-quality-selector`
        qualitySelector.innerHTML = `
          <button class="vjs-menu-button vjs-menu-button-popup vjs-button" type="button" aria-disabled="false" aria-haspopup="true" aria-expanded="false">
            <span class="vjs-icon-placeholder" aria-hidden="true">Auto</span>
            <span class="vjs-control-text" aria-live="polite"></span>
          </button>
          <div class="vjs-menu">
            <ul class="vjs-menu-content">
              <li class="vjs-menu-title" tabindex="-1">Quality</li>
            </ul>
          </div>
        `
        const controlBar = videoElement.parentNode.querySelector('.vjs-control-bar')
        const spacer = videoElement.parentNode.querySelector('.vjs-spacer')
        if (controlBar && spacer) {
          controlBar.insertBefore(qualitySelector, spacer) // vjs-spacer の前に追加
        } else if (controlBar) {
          console.warn(`vjs-spacer not found for video ${videoElement.id}, appending to control bar`)
          controlBar.appendChild(qualitySelector)
        } else {
          console.error(`Control bar not found for video ${videoElement.id}`)
          return
        }
      }

      const qualityMenu = qualitySelector.querySelector('.vjs-menu-content')
      if (!qualityMenu) {
        console.error('Quality menu not found')
        return
      }

      // すべて元の解像度を削除
      const existingItems = qualityMenu.querySelectorAll('li:not(.vjs-menu-title)')
      existingItems.forEach((item) => item.remove())

      // "Auto"を追加
      const autoItem = document.createElement('li')
      autoItem.className = 'vjs-menu-item'
      autoItem.innerHTML = 'Auto'
      autoItem.addEventListener('click', () => {
        hls.currentLevel = -1
        updateSelectedQuality(-1)
        console.log(`Selected Auto for video ${videoElement.id}`)
      })
      qualityMenu.appendChild(autoItem)

      // hls.levels からの解像度を追加
      hls.levels.forEach((level, index) => {
        const qualityItem = document.createElement('li')
        qualityItem.className = 'vjs-menu-item'
        const qualityLabel = level.height ? `${level.height}p` : `Quality ${index + 1}`
        qualityItem.innerHTML = qualityLabel
        qualityItem.addEventListener('click', () => {
          hls.currentLevel = index
          updateSelectedQuality(index)
          console.log(`Selected ${qualityLabel} for video ${videoElement.id}`)
        })
        qualityMenu.appendChild(qualityItem)
      })

      // 初期の解像度："Auto"
      hls.currentLevel = -1
      updateSelectedQuality(-1)

      function updateSelectedQuality(selectedIndex) {
        const allItems = qualityMenu.querySelectorAll('.vjs-menu-item')
        allItems.forEach((item, idx) => {
          item.classList.toggle('vjs-selected', selectedIndex === idx - 1)
        })
        const buttonLabel = qualitySelector.querySelector('.vjs-icon-placeholder')
        if (buttonLabel) {
          buttonLabel.innerHTML = selectedIndex === -1 ? 'Auto' : `${hls.levels[selectedIndex].height}p`
        }
      }

      // 解像度の更新
      hls.on(Hls.Events.LEVEL_SWITCHED, function (event, data) {
        if (qualityMenu) {
          updateSelectedQuality(hls.currentLevel)
        }
      })
    }
    const playerInstance = player[videoID]

    // Hls.js
    let hls = null
    let qualityMenuAdded = false
    let manifestParsed = false

    // MANIFEST_PARSEDイベントでの処理を再生開始時まで遅延させる関数
    function handleManifestParsed() {
      if (qualityMenuAdded || !manifestParsed) {
        return
      }
      qualityMenuAdded = true

      if (hls && hls.levels) {
        // console.log(`HLS Levels for video ${videoItem.id}:`, hls.levels)
        addQualityMenu(videoItem, player, hls)
        try {
          player.hlsQualitySelector({ displayCurrentQuality: true })
        } catch (e) {
          console.warn(`hlsQualitySelector failed for video ${videoItem.id}:`, e)
        }
      }
    }

    // iOS環境ではネイティブHLSを使用（HLS.jsはiOS環境で問題が発生する可能性があるため）
    // それ以外の環境ではHLS.jsを使用可能な場合に使用
    const isIOS = deviceOS === 'ios'
    let useHlsJs = !isIOS && Hls.isSupported()

    if (useHlsJs) {
      // HLS.jsの初期化は即座に行うが、autoStartLoad: falseでプリロードを防ぐ
      // 実際の読み込みは再生開始時にstartLoad()で開始
      hls = new Hls({
        autoStartLoad: false, // 自動読み込みを無効化（プリロードを防ぐ）
        maxNumRetry: 10, // 認証エラー時の無制限リトライを防止（障害対応）
      })

      hls.loadSource(videoUrl)
      hls.attachMedia(playerInstance.tech().el())

      let hlsNetworkErrorCount = 0
      const HLS_MAX_NETWORK_ERRORS = 10

      hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
        manifestParsed = true
        hlsNetworkErrorCount = 0 // 正常にマニフェスト取得できたらリセット
      })
      hls.on(Hls.Events.FRAG_LOADED, function () {
        hlsNetworkErrorCount = 0 // TS取得成功時にリセット
      })
      player[videoID].on('playing', function () {
        hlsNetworkErrorCount = 0 // 再生再開成功時にリセット
      })

      hls.on(Hls.Events.ERROR, function (event, data) {
        if (shouldCountHlsNetworkError(data)) {
          hlsNetworkErrorCount++
          if (hlsNetworkErrorCount > HLS_MAX_NETWORK_ERRORS) {
            hls.destroy()
            player[videoID].pause()
            player[videoID].error({ code: 4, message: '再生エラーが繰り返し発生したため停止しました' })
            return
          }
        }
        console.error(`HLS Error for video ${videoItem.id}:`, data)
      })

      // 再生開始時に実際の読み込みを開始（プリロードを防ぐため）
      let hlsLoadStarted = false
      player[videoID].on('play', function () {
        if (!hlsLoadStarted) {
          hlsLoadStarted = true
          hls.startLoad() // 実際の読み込みを開始
        }
        // MANIFEST_PARSEDが既に発火している場合に備えて、handleManifestParsed()も呼ぶ
        if (manifestParsed) {
          handleManifestParsed()
        }
      })
    } else if (player[videoID].tech().el().canPlayType('application/vnd.apple.mpegurl')) {
      // Fallback for Safari / iOS
      // srcの設定は即座に行うが、preload: 'none'により実際の読み込みは再生開始時まで遅延
      playerInstance.src({ src: videoUrl, type: 'application/vnd.apple.mpegurl' })

      playerInstance.ready(async function () {
        const levels = await fetchNativeHlsLevels(videoUrl)
        console.log('Levels:', levels)

        const fakeHls = {
          levels: levels, // 解像度を追加する
          currentLevel: -1,
          on: function () {},
        }

        // 再生開始時に画質メニューを追加
        function addQualityMenuForIOS() {
          if (!qualityMenuAdded) {
            qualityMenuAdded = true
            addQualityMenu(videoItem, playerInstance, fakeHls)
          }
        }

        // 既に再生中の場合は即座に実行
        if (!playerInstance.paused()) {
          addQualityMenuForIOS()
        } else {
          // 再生開始時に実行
          playerInstance.on('play', addQualityMenuForIOS)
        }
      })
    } else {
      console.log('ブラウザーはHLSをサポートしていません')
    }

    player[videoID].addChild(CreateSkip(player, videoID), {})

    let chapter = videoItem.dataset.chapter
    if (chapter) {
      chapter = decodeURIComponent(chapter)
      addChapter(videoID, chapter)
    }
    //  ###    ###   #####   ####      ###    ##
    //  ## #  # ##  ##   ##  ##  ##   ## ##   ##
    //  ##  ##  ##  ##   ##  ##  ##  ##   ##  ##
    //  ##      ##  ##   ##  ##  ##  #######  ##
    //  ##      ##   #####   ####    ##   ##  ######
    // モーダル開閉時に動画を止める
    window.addEventListener('click', function (e) {
      // 指定のクラスを持つ
      if (e.target.classList.contains('js-modal-open') || e.target.classList.contains('js-modal-close')) {
        player[videoID].pause()
      }
    })

    // 解像度を取得する
    async function fetchNativeHlsLevels(videoUrl) {
      try {
        const response = await fetch(videoUrl)
        const text = await response.text()

        // Regex
        // #EXT-X-STREAM-INF:BANDWIDTH=300000,RESOLUTION=640x360
        const regex = /#EXT-X-STREAM-INF:.*BANDWIDTH=(\d+).*RESOLUTION=(\d+)x(\d+)/g
        const levels = []
        let match

        while ((match = regex.exec(text)) !== null) {
          const bandwidth = parseInt(match[1])
          const height = parseInt(match[3])
          levels.push({ bitrate: bandwidth, height })
        }
        return levels
      } catch (err) {
        return []
      }
    }

    //  ##   ##   #####   ##      ##   ##  ###    ###  #####
    //  ##   ##  ##   ##  ##      ##   ##  ## #  # ##  ##
    //  ##   ##  ##   ##  ##      ##   ##  ##  ##  ##  #####
    //   ## ##   ##   ##  ##      ##   ##  ##      ##  ##
    //    ###     #####   ######   #####   ##      ##  #####
    // 音量設定の記憶
    saveVolume()
    function saveVolume() {
      player[videoID].on(['loadstart'], function (e) {
        // 動画準備段階
        const videoVolume = getCookie('videoVolume') // Cookie取得
        const videoMuted = getCookie('videoMuted') // Cookie取得
        if (videoMuted === 'true') {
          player[videoID].muted(true) // ミュートを反映
          setCookie('videoMuted', videoMuted, 60 * 60 * 24 * 365, false) // 音量をCookieに格納
        }
        if (!isNaN(videoVolume)) {
          player[videoID].volume(parseFloat(videoVolume, 10)) // 音量を反映
          setCookie('videoVolume', videoVolume, 60 * 60 * 24 * 365, false) // 音量をCookieに格納
        }
      })
      player[videoID].on('volumechange', function () {
        // 音量変更時
        setCookie('videoMuted', player[videoID].muted(), 60 * 60 * 24 * 365, false) // ミュート状態をCookieに格納
        setCookie('videoVolume', player[videoID].volume(), 60 * 60 * 24 * 365, false) // 音量をCookieに格納
      })
    }

    //    ###    #####   ##
    //   ## ##   ##  ##  ##
    //  ##   ##  #####   ##
    //  #######  ##      ##
    //  ##   ##  ##      ##
    // 再生状況送信API
    let playDataTimer
    let lastSendTime = 0 // 最後に送信した時間
    let seekTime = 0 // シークした時間
    player[videoID].on(['seeked'], function (e) {
      // シークされた
      const time = Math.floor(player[videoID].currentTime()) // 小数切り捨てで再生時間取得
      const endTime = Math.floor(player[videoID].duration()) // 動画全体の再生時間
      // console.log(time)
      if (lastSendTime + 5 <= time && time !== endTime) {
        // 最後の時間より5秒以上進んでおり、かつ動画の末尾でない場合は送信予約
        seekTime = time - (time % 5)
      }
    })

    // 初回再生時限定の送信
    let firstSend = false
    player[videoID].on(['play'], function (e) {
      playTimeApiErrorCount = 0
      if (!firstSend) {
        playTimeAPI(videoItem.dataset.token, secToTime(seekTime), 0)
        firstSend = true
      }

      // 他の動画を止める
      for (const key in player) {
        if (!player.hasOwnProperty(key)) {
          continue
        }

        if (parseInt(key, 10) === parseInt(videoID, 10)) {
          continue
        }
        player[key].pause()
      }
    })

    player[videoID].on(['playing'], function (e) {
      // シーク時の再生予約を実行
      // videoTrayOn()
      if (seekTime !== 0) {
        // シーク時間が0秒以外なら実行
        playTimeAPI(videoItem.dataset.token, secToTime(seekTime), 0)
        lastSendTime = seekTime
      }
      seekTime = 0

      // 定期送信処理を実行
      playDataTimer = setInterval(function () {
        const time = Math.floor(player[videoID].currentTime()) // 小数切り捨てで再生時間取得
        // console.log(time)
        if (time !== 0 && time % 5 === 0 && time !== lastSendTime) {
          // 0秒以外の5の倍数秒、かつ最後に記録した時間と異なれば送信する
          playTimeAPI(videoItem.dataset.token, secToTime(time), 0)
          lastSendTime = time
        }
      }, 500)
    })

    player[videoID].on(['pause'], function (e) {
      clearInterval(playDataTimer)
    })
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clearInterval(playDataTimer)
    })
    player[videoID].on(['ended'], function (e) {
      // videoTrayOn()
      // 動画が終わったら送信する
      clearInterval(playDataTimer)
      const time = Math.floor(player[videoID].currentTime()) // 小数切り捨てで再生時間取得
      playTimeAPI(videoItem.dataset.token, secToTime(time), 1)
    })

    //  #####  ##   ##  #####  ##     ##  ######
    //  ##     ##   ##  ##     ####   ##    ##
    //  #####  ##   ##  #####  ##  ## ##    ##
    //  ##      ## ##   ##     ##    ###    ##
    //  #####    ###    #####  ##     ##    ##
    player[videoID].on(['loadeddata'], function (e) {
      videoQualityButtonFix(videoID)
      const qua = document.querySelector('.video-' + videoID + ' .vjs-quality-selector')
      if (qua) {
        qua.classList.add('active')
        initMobileQualityMenu(videoID)
      }

      barBtnSort(videoID) // ボタンを整列する
      popHoverMenu(videoItem) // 画面ホバーメニューを有効化する
      // videoDebug(e)
    })

    const playBtn = document.getElementById('hoverBtn-play--' + videoID)
    player[videoID].on(['play', 'pause', 'ended'], function (e) {
      // 再生ボタンのアイコンを差し替える
      if (player[videoID].paused()) {
        playBtn.classList.remove('play')
      } else {
        playBtn.classList.add('play')
      }
      if (player[videoID].ended()) {
        playBtn.classList.remove('play')
      }
    })

    // 秒数skip
    player[videoID].getChild('controlBar').addChild(addRateBtn(player, videoID), {}, 6)

    // シアターモード
    player[videoID].getChild('controlBar').addChild(addTheatreBtn(player, videoID), {}, 6)

    // 移動ボタン
    player[videoID].getChild('controlBar').addChild(addMoveBtn(player, videoID), {}, 6)

    // 追加メニューボタン
    player[videoID].getChild('controlBar').addChild(addMoreMenuBtn(player, videoID), {}, 6)

    // チャプター
    player[videoID].getChild('controlBar').addChild(addChapterBtn(player, videoID), {}, 6)

    // 画質表示
    player[videoID].getChild('controlBar').addChild(quality(player, videoID))

    const vtt = videoItem.dataset.vtt
    if (vtt) {
      // console.log(vtt)
      player[videoID].vttThumbnails({
        src: vtt,
      })
    }
    barBtnSort(videoID) // ボタンを整列する

    window.addEventListener('resize', function (e) {
      barBtnSort(videoID) // ボタンを整列する
    })

    // SPではタッチして自動的にプレビューが非表示
    fixVttThumbnail(videoID)

    function fixVttThumbnail(videoID) {
      const playerInstance = player[videoID]
      if (!playerInstance) return

      playerInstance.ready(function () {
        const progressControl = playerInstance.controlBar.progressControl
        if (!progressControl || !progressControl.el_) return // SPのタッチイベント
        ;['touchend', 'touchcancel'].forEach((eventName) => {
          progressControl.el_.addEventListener(eventName, function () {
            // 現在のプレイヤーのサムネイル
            const thumbnail = playerInstance.el_.querySelector('.vjs-vtt-thumbnail-display')
            if (thumbnail) {
              thumbnail.classList.add('show')
              setTimeout(() => thumbnail.classList.remove('show'), 500)
            }
          })
        })
      })
    }
  }

  //  ####     #####   ##   ##  #####   ##      #####
  //  ##  ##  ##   ##  ##   ##  ##  ##  ##      ##
  //  ##  ##  ##   ##  ##   ##  #####   ##      #####
  //  ##  ##  ##   ##  ##   ##  ##  ##  ##      ##
  //  ####     #####    #####   #####   ######  #####

  const doubleTapTime = 350 // ダブルタップの受付時間
  let tapCount = 0

  let hideTimer = null // UIを隠すタイマー
  window.tap = function (videoID, move) {
    if (!tapCount) {
      // タップの回数を+1
      ++tapCount
      // firstTapAct()
      setTimeout(function () {
        if (tapCount === 1) {
          // 指定ミリ秒以内に2回目のタップがなければシングルタップと判定
          tapCount = 0
          // singleTapAct()
        }
      }, doubleTapTime)
    } else {
      tapCount = 0
      let skipTime = 0.1
      if (move === 'prev') {
        // コマ戻し
        skipTime = -0.1
      }
      // 一定時間ホバーUIを隠す
      document.getElementById('videoHoverMenu--' + videoID).classList.add('hide')
      clearTimeout(hideTimer)
      hideTimer = setTimeout(() => {
        document.getElementById('videoHoverMenu--' + videoID).classList.remove('hide')
      }, 1000)

      videoSkip(videoID, skipTime, true)
    }
  }

  //  #####  ##   ##  ##     ##   ####  ######  ##   #####   ##     ##
  //  ##     ##   ##  ####   ##  ##       ##    ##  ##   ##  ####   ##
  //  #####  ##   ##  ##  ## ##  ##       ##    ##  ##   ##  ##  ## ##
  //  ##     ##   ##  ##    ###  ##       ##    ##  ##   ##  ##    ###
  //  ##      #####   ##     ##   ####    ##    ##   #####   ##     ##
  function isDeviceOS() {
    const ua = navigator.userAgent.toLowerCase()
    if (ua.indexOf('iphone') > -1) {
      // iPhone
      return 'ios'
    }
    if (ua.indexOf('ipad') > -1) {
      // iPad
      return 'ios'
    }
    if (ua.indexOf('android') > -1 && ua.indexOf('mobile') > -1) {
      // Android
      return 'android'
    }
    if (ua.indexOf('android') > -1 && ua.indexOf('mobile') === -1) {
      // Android Tablet
      return 'android'
    }
    return 'pc'
  }

  //    ###    #####   ##            ######  ##  ###    ###  #####
  //   ## ##   ##  ##  ##              ##    ##  ## #  # ##  ##
  //  ##   ##  #####   ##  ########    ##    ##  ##  ##  ##  #####
  //  #######  ##      ##              ##    ##  ##      ##  ##
  //  ##   ##  ##      ##              ##    ##  ##      ##  #####

  function playTimeAPI(token, time, finish = 0) {
    if (playTimeApiErrorCount >= PLAY_TIME_API_MAX_ERRORS) return
    let ajax = new XMLHttpRequest()
    ajax.open('get', playTimeApiUrl + '?token=' + token + '&time=' + time + '&finish=' + finish, true)
    ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
    ajax.responseType = 'document'
    ajax.timeout = 10000
    ajax.send()
    ajax.onload = function () {
      if (ajax.status >= 200 && ajax.status < 400) {
        playTimeApiErrorCount = 0
      } else if (ajax.status === 401 || ajax.status === 403) {
        playTimeApiErrorCount++
      }
    }
    ajax.ontimeout = function () {
      playTimeApiErrorCount++
    }
    ajax.onerror = function () {
      playTimeApiErrorCount++
    }
    ajax.onloadend = function () {
      ajax = null
    }
  }

  //   ####  #####   ####            ######  ##  ###    ###  #####
  //  ##     ##     ##                 ##    ##  ## #  # ##  ##
  //   ###   #####  ##     ########    ##    ##  ##  ##  ##  #####
  //     ##  ##     ##                 ##    ##  ##      ##  ##
  //  ####   #####   ####              ##    ##  ##      ##  #####

  /**
   * 総秒数を時:分:秒に変換
   * sec{int} 秒数
   */
  function secToTime(sec) {
    // 時間を求める
    const hour = Math.floor(sec / 3600)
    sec %= 3600

    // 分を求める
    const minute = Math.floor(sec / 60)
    sec %= 60

    // 表示用にゼロパディングをかける
    const hourView = String(hour).padStart(2, '0')
    const minuteView = String(minute).padStart(2, '0')
    const secView = String(sec).padStart(2, '0')

    return hourView + ':' + minuteView + ':' + secView
  }

  //   #####   ##   ##    ###
  //  ##   ##  ##   ##   ## ##
  //  ##   ##  ##   ##  ##   ##
  //   #####   ##   ##  #######
  //  ##        #####   ##   ##
  // 動画サイズから画質を求める
  function setQuality(item) {
    const text = item.innerText

    if (text === 'auto' || ~text.indexOf('Auto')) {
      // item.innerText = '自動'

      // item.dataset.quality = 'auto'
      return
    }
    if (text === '4K') {
      return
    }
    if (text === 'undefinedp') {
      // 不明な画質データは消す
      console.log(text)
      item.style.display = 'none'
      return
    }
    const size = parseInt(text, 10)
    if (size >= 2160) {
      item.innerText = '4K'

      item.dataset.quality = '4k'
    } else if (size >= 1080) {
      item.innerText = 'FHD'

      item.dataset.quality = 'fhd'
    } else if (size >= 720) {
      item.innerText = 'HD'

      item.dataset.quality = 'hd'
    } else if (size <= 719) {
      item.innerText = 'SD'

      item.dataset.quality = 'sd'
    }
  }

  function videoQualityButtonFix(videoID) {
    const quaLabel = document.querySelectorAll(
      '.video-' + videoID + ' .vjs-quality-selector .vjs-icon-placeholder,.vjs-menu-item'
    )

    for (const iterator of quaLabel) {
      setQuality(iterator)
    }

    const observeItem = document.querySelector('.video-' + videoID + ' .vjs-quality-selector button')
    if (observeItem) {
      const observer = new MutationObserver((records) => {
        if (records[0].target.tagName !== 'SPAN') {
          return
        }
        setQuality(records[0].target)
      })
      observer.observe(observeItem, {
        // 指定要素の変化を監視
        childList: true, // 子要素の監視
        subtree: true, // 子孫要素の監視
        // attributes: true, // 属性の変化を監視
        // attributeFilter: ['style'], // 監視する属性を限定する場合は指定
        characterData: true, // 文字の監視
      })
    }
  }

  //  ##   ##   #####   ##   ##  #####  #####
  //  ##   ##  ##   ##  ##   ##  ##     ##  ##
  //  #######  ##   ##  ##   ##  #####  #####
  //  ##   ##  ##   ##   ## ##   ##     ##  ##
  //  ##   ##   #####     ###    #####  ##   ##

  // ホバーメニューの作成
  function CreateSkip(player, videoID) {
    /*
 <button type="button" title="前のチャプターへ" class="videoFrontBtn__item flex vcenter hcenter" onclick="videoChapterShift(${videoID},'prev')">
      <i class="videoFrontBtn__icon videoFrontBtn__icon--back play-icon icon-video-chapter-prev"></i>
    </button>
        <button type="button" title="次のチャプターへ" class="videoFrontBtn__item flex vcenter hcenter" onclick="videoChapterShift(${videoID},'next')">
    <i class="videoFrontBtn__icon videoFrontBtn__icon--back play-icon icon-video-chapter-next"></i>
    </button>
    */
    let newElement = `
<div id="videoHoverMenu--${videoID}" class="videoHoverMenu">
  <div id="cover-btn"class="js-coverBtn videoFrontBtn flex vcenter hcenter">
    <button id="hoverBtn-play--${videoID}" type="button" title="再生" class="videoFrontBtn__item videoFrontBtn__item--play flex vcenter hcenter" onclick="playToggle(${videoID})">
      <i class="videoFrontBtn__icon videoFrontBtn__icon--play play-icon icon-video-play"></i>
      <i class="videoFrontBtn__icon videoFrontBtn__icon--stop play-icon icon-video-pause"></i>
    </button>
    </div>
</div>
<button id="tapArea--${videoID}-prev" type="button" class="videoTapArea videoTapArea--prev" onclick="tap(${videoID},'prev')"></button>
<button id="tapArea--${videoID}-next" type="button" class="videoTapArea videoTapArea--next" onclick="tap(${videoID},'next')"></button>
<div id="hoverMenu-rightTop" class="videoHoverMenu videoHoverMenu--rightTop flex vcenter hend"></div>
`

    const Component = videojs.getComponent('Component')
    const result = new Component(player[videoID])
    result.el().innerHTML = newElement
    return result
  }
  //            #####    #####   #####
  //            ##  ##  ##   ##  ##  ##
  //  ########  #####   ##   ##  #####
  //            ##      ##   ##  ##
  //            ##       #####   ##
  // ホバーメニュー展開
  function popHoverMenu(videoItem) {
    const timeout = 500 // 消滅時間
    let menuTimer
    // 画面ホバーで一定時間メニュー展開
    videoItem.addEventListener('mousemove', function () {
      setTimeout(() => {
        videoItem.classList.add('hover')
        clearTimeout(menuTimer)
        menuTimer = setTimeout(function () {
          videoItem.classList.remove('hover')
        }, timeout)
      }, 50)
    })

    // ボタンが押されたら展開延長
    const hoverBtnList = videoItem.querySelectorAll('button')
    for (const btn of hoverBtnList) {
      btn.addEventListener('click', function () {
        clearTimeout(menuTimer)
        menuTimer = setTimeout(function () {
          videoItem.classList.remove('hover')
        }, timeout)
      })
    }
  }

  //            #####   ##        ###    ##    ##
  //            ##  ##  ##       ## ##    ##  ##
  //  ########  #####   ##      ##   ##    ####
  //            ##      ##      #######     ##
  //            ##      ######  ##   ##     ##
  const playToggle = function (videoID) {
    // 再生と停止を切り替え

    console.log(videoID)

    if (player[videoID].paused()) {
      player[videoID].play()
    } else {
      player[videoID].pause()
    }
  }
  window.playToggle = playToggle

  //             ####  ##  ##  ##  #####
  //            ##     ## ##   ##  ##  ##
  //  ########   ###   ####    ##  #####
  //               ##  ## ##   ##  ##
  //            ####   ##  ##  ##  ##

  const videoSkip = function videoSkip(videoID, sec, pause = false) {
    if (pause) {
      // ポーズを伴う
      player[videoID].pause()
    }
    let newTime = player[videoID].currentTime() + sec
    player[videoID].currentTime(newTime)
  }
  window.videoSkip = videoSkip

  //             ####  ##   ##    ###    #####   ######  #####  #####
  //            ##     ##   ##   ## ##   ##  ##    ##    ##     ##  ##
  //  ########  ##     #######  ##   ##  #####     ##    #####  #####
  //            ##     ##   ##  #######  ##        ##    ##     ##  ##
  //             ####  ##   ##  ##   ##  ##        ##    #####  ##   ##
  // 前後のチャプターに移動する
  window.videoChapterShift = function (videoID, mode = '') {
    const nowSec = player[videoID].currentTime()

    const chapterList = document.querySelectorAll('.js-chapter-' + videoID + ' .js-chapter')

    if (mode === 'next') {
      for (let index = 0; index < chapterList.length; index++) {
        const element = chapterList[index]
        const chapterSec = parseInt(element.value, 10)
        console.log({ element })
        console.log({ chapterSec })
        if (chapterSec >= nowSec) {
          player[videoID].currentTime(chapterSec)
          return
        }
      }
    } else {
      for (let index = chapterList.length - 1; index >= 0; index--) {
        const element = chapterList[index]
        const chapterSec = parseInt(element.value, 10)
        console.log({ element })
        console.log({ chapterSec })
        if (chapterSec < nowSec - 1) {
          player[videoID].currentTime(chapterSec)
          return
        }
      }
    }
    window.popToast('移動するチャプターが見つかりませんでした')
  }

  //  #####     ###    #####
  //  ##  ##   ## ##   ##  ##
  //  #####   ##   ##  #####
  //  ##  ##  #######  ##  ##
  //  #####   ##   ##  ##   ##

  // 再生速度ボタン
  function addRateBtn(player, videoID) {
    let newElement = `

<div id="videoSpeed-${videoID}-box" class="videoSpeed notranslate">
    <div id="videoSpeed-${videoID}-list" class="videoSpeed__list">
        <button type="button" class="videoSpeed__btn flex vcenter" value="0.25" onclick="changeRate(this.value,${videoID})">0.25</button>
        <button type="button" class="videoSpeed__btn flex vcenter" value="0.50" onclick="changeRate(this.value,${videoID})">0.50</button>
        <button type="button" class="videoSpeed__btn flex vcenter" value="1.00" onclick="changeRate(this.value,${videoID})">1.00</button>
        <button type="button" class="videoSpeed__btn flex vcenter" value="1.25" onclick="changeRate(this.value,${videoID})">1.25</button>
        <button type="button" class="videoSpeed__btn flex vcenter" value="1.50" onclick="changeRate(this.value,${videoID})">1.50</button>
        <button type="button" class="videoSpeed__btn flex vcenter" value="2.00" onclick="changeRate(this.value,${videoID})">2.00</button>
    </div>
    <button type="button" id="videoSpeed-${videoID}-label" class="js-videoSpeedOpen videoSpeed__btn videoSpeed__btn--label flex vcenter hend" data-video-id="${videoID}">1.00</button>
</div>
`

    const Component = videojs.getComponent('Component')
    const result = new Component(player[videoID])
    result.el().innerHTML = newElement

    return result
  }

  // シアターモードボタン
  function addTheatreBtn(player, videoID) {
    let newElement = `

<div id="videoTheatre-${videoID}-box" class="videoTheatre notranslate">
    <button type="button" id="videoTheatre-${videoID}-label" class="js-videoTheatre videoTheatre__btn videoTheatre__btn--label flex vcenter hcenter" data-video-id="${videoID}" title="シアターモード切り替え">
      <i class="is-false icon-theatre"></i>
    </button>
</div>

`

    const Component = videojs.getComponent('Component')
    const result = new Component(player[videoID])
    result.el().innerHTML = newElement

    return result
  }

  //  ###    ###   #####   ##   ##  #####
  //  ## #  # ##  ##   ##  ##   ##  ##
  //  ##  ##  ##  ##   ##  ##   ##  #####
  //  ##      ##  ##   ##   ## ##   ##
  //  ##      ##   #####     ###    #####

  // 移動ボタン
  function addMoveBtn(player, videoID) {
    let newElement = `

<div id="videoMove-${videoID}-box" class="js-clickToggle--videoMove-${videoID} videoMoveList notranslate flex hcenter vcenter">

    <button type="button" title="前のチャプターへ" class="videoMoveList__item videoMoveList__item--cPrev flex vcenter hcenter" onclick="videoChapterShift(${videoID},'prev')">
      <i class="videoFrontBtn__icon videoFrontBtn__icon--back play-icon icon-video-chapter-prev"></i>
    </button>

    <button type="button" title="30秒戻る" class="videoMoveList__item flex vcenter hcenter" onclick="videoSkip(${videoID},-30)">
      <i class="videoFrontBtn__icon videoFrontBtn__icon--back play-icon icon-video-back-30"></i>
    </button>
    <button type="button" title="10秒戻る" class="videoMoveList__item flex vcenter hcenter" onclick="videoSkip(${videoID},-10)">
      <i class="videoFrontBtn__icon videoFrontBtn__icon--back play-icon icon-video-back-10"></i>
    </button>
    <button type="button" title="コマ戻し" class="videoMoveList__item flex vcenter hcenter" onclick="videoSkip(${videoID},-0.1)">
      <i class="videoFrontBtn__icon videoFrontBtn__icon--back play-icon icon-video-back-1"></i>
    </button>
    <button type="button" title="コマ送り" class="videoMoveList__item flex vcenter hcenter" onclick="videoSkip(${videoID},0.1)">
    <i class="videoFrontBtn__icon videoFrontBtn__icon--back play-icon icon-video-skip-1"></i>
    </button>
    <button type="button" title="10秒進む" class="videoMoveList__item flex vcenter hcenter" onclick="videoSkip(${videoID},10)">
    <i class="videoFrontBtn__icon videoFrontBtn__icon--back play-icon icon-video-skip-10"></i>
    </button>
    <button type="button" title="30秒進む" class="videoMoveList__item flex vcenter hcenter" onclick="videoSkip(${videoID},30)">
    <i class="videoFrontBtn__icon videoFrontBtn__icon--back play-icon icon-video-skip-30"></i>
    </button>

    <button type="button" title="次のチャプターへ" class=" videoMoveList__item videoMoveList__item--cNext flex vcenter hcenter" onclick="videoChapterShift(${videoID},'next')">
    <i class="videoFrontBtn__icon videoFrontBtn__icon--back play-icon icon-video-chapter-next"></i>
    </button>
</div>
`

    const Component = videojs.getComponent('Component')
    const result = new Component(player[videoID])
    result.el().innerHTML = newElement

    return result
  }
  // 移動ボタン
  function addMoreMenuBtn(player, videoID) {
    let newElement = `

<div id="videoMore-${videoID}-box" class="videoSp videoMoreMenu notranslate flex hcenter vcenter">
    <button type="button" title="追加メニュー" class="js-clickToggle videoMoreMenu__item flex vcenter hcenter" data-toggle-group="videoMove-${videoID}">
      <i class="videoFrontBtn__icon videoFrontBtn__icon--back play-icon icon-video-menu"></i>
    </button>
</div>

`

    const Component = videojs.getComponent('Component')
    const result = new Component(player[videoID])
    result.el().innerHTML = newElement

    return result
  }

  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-videoTheatre')) {
      return
    }
    const videoID = e.target.dataset.videoId

    document.querySelector('.video-' + videoID).parentNode.classList.toggle('videoFrame--theatre')
  })

  // フルスクリーンチャプター展開ボタン
  function addChapterBtn(player, videoID) {
    let newElement = ''

    const chapterTarget = document.querySelector('.video-' + videoID) // 設置先

    if (chapterTarget.dataset.chapter !== undefined && chapterTarget.dataset.chapter !== '') {
      // チャプター情報があればボタンを生成
      newElement = `
<button type="button" id="videoChapterFull-${videoID}" class="js-chapterOpen js-chapterOpen--${videoID} videoChapterBtn flex vcenter hcenter" data-target=".js-chapterOpen-box--${videoID}">
    チャプター選択
    <i class="is-false videoChapterBtn__icon icon-up"></i>
</button>
`
    }
    const Component = videojs.getComponent('Component')
    const result = new Component(player[videoID])
    result.el().innerHTML = newElement

    return result
  }

  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-chapterOpen')) {
      return
    }
    e.target.classList.toggle('active')
    document.querySelector(e.target.dataset.target).classList.toggle('active')
  })

  // hovermenu再生ボタン
  let playButton = document.getElementById('hovermenu-play')
  if (playButton) {
    playButton.addEventListener('click', (event) => {
      if (player.paused()) {
        player.play()
      } else {
        player.pause()
      }
    })
  }

  //  ##  ##     ##  #####   #####
  //  ##  ####   ##  ##     ##   ##
  //  ##  ##  ## ##  #####  ##   ##
  //  ##  ##    ###  ##     ##   ##
  //  ##  ##     ##  ##      #####

  // コントロールバーに画質表示
  function quality(player, videoID) {
    /*html*/
    let newElement = `
<div class="videoSpRight flex vcenter">
  <button id="videoMenuOpen" type="button" title="追加メニュー" class="sp-item videoMenu flex vcenter hcenter">
    <i class="is-false videoMenu__icon icon-movie-menu"></i>
  </button>
</div>
`
    const Component = videojs.getComponent('Component')
    const result = new Component(player[videoID])
    result.el().innerHTML = newElement
    return result
  }

  //    ####  #####   #####  #####  ####
  //   ##     ##  ##  ##     ##     ##  ##
  //    ###   #####   #####  #####  ##  ##
  //      ##  ##      ##     ##     ##  ##
  //   ####   ##      #####  #####  ####

  const changeRate = function (rate, videoID) {
    // 速度を取得して反映
    document.getElementById('videoSpeed-' + videoID + '-label').innerText = rate

    player[videoID].playbackRate(rate)

    // 速度メニューのホバー判定を消す
    document.getElementById('videoSpeed-' + videoID + '-list').style.display = 'none'
    setTimeout(() => {
      document.getElementById('videoSpeed-' + videoID + '-list').style.display = ''
    }, 500)
    document.getElementById('videoSpeed-' + videoID + '-box').classList.remove('hover')
  }
  window.changeRate = changeRate

  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-videoSpeedOpen')) {
      return
    }
    const videoID = e.target.dataset.videoId
    const box = document.getElementById('videoSpeed-' + videoID + '-box')
    // ホバーを切り替える
    box.classList.toggle('hover')
  })

  //   ####  ##   ##    ###    #####   ######  #####  #####
  //  ##     ##   ##   ## ##   ##  ##    ##    ##     ##  ##
  //  ##     #######  ##   ##  #####     ##    #####  #####
  //  ##     ##   ##  #######  ##        ##    ##     ##  ##
  //   ####  ##   ##  ##   ##  ##        ##    #####  ##   ##
  function addChapter(videoID, chapter) {
    // スライダー枠を設置する
    const chapterTarget = document.querySelector('.video-' + videoID).parentNode // 設置先

    // ビデオ下のセクション
    const chapterBlock = document.createElement('div')
    chapterBlock.setAttribute('class', 'chapterSlide')

    chapterTarget.parentNode.insertBefore(chapterBlock, chapterTarget.nextSibling) // 要素の直後に追加

    // フルスクリーン時のUI
    const chapterBlockFull = document.createElement('div')
    chapterBlockFull.setAttribute('class', 'js-chapterOpen-box--' + videoID + ' chapterSlide chapterSlide--full')
    chapterTarget.querySelector('.vjs-control-bar').appendChild(chapterBlockFull) // 最後の子要素として追加

    // スライダーを生成する
    let html = ''
    html += `
<div class="chapterSlide__box">
    <div class="js-chapter-${videoID} swiper-container">
        <div class="swiper-wrapper">
`

    const json = JSON.parse(chapter) // テキストをJSONにパース
    let count = 0
    for (const key in json) {
      if (!json.hasOwnProperty(key)) {
        continue
      }
      ++count
      const no = String(count).padStart(2, '0')
      const time = sec2hms(json[key]['sec'])

      html += `
            <div class="swiper-slide flex">
              <button type="button" class="js-chapter flex chapterSlide__item" value="${json[key]['sec']}" data-target="${videoID}">
                  <div class="is-false">
`
      if (json[key]['img']) {
        html += `
        <div class="chapterSlide__img">
        <div class="md-lay zoom block">
        <div class="lay-bg">
        <img src="${json[key]['img']}" alt="チャプター${count}" width="150">
        </div>
        </div>
        </div>
        `
      }
      html += `
                      <div class="chapterSlide__data">
                          <div class="chapterSlide__time">
                              ${time}
                          </div>
                          <div class="chapterSlide__title">
                             ${json[key]['text']}
                          </div>
                      </div>
                  </div>
              </button>
            </div>
`
      // console.log(key + ': ' + json[key])
    }
    html += `

        </div>
    </div>
    <button type="button" class="chapterSlide__move chapterSlide__move--prev swiper-button-prev--chapter-${videoID} flex vcenter hcenter">
      <i class="icon-left"></i>
    </button>
    <button type="button" class="chapterSlide__move chapterSlide__move--next swiper-button-next--chapter-${videoID} flex vcenter hcenter">
      <i class="icon-right"></i>
    </button>
</div>
`
    chapterBlock.innerHTML = html
    chapterBlockFull.innerHTML = html

    const slideItem = document.getElementsByClassName('js-chapter-' + videoID)

    if (slideItem[0]) {
      // Swiperコンテナを検出したら実行
      // eslint-disable-next-line no-unused-vars

      const sliderName = 'chapter-' + videoID
      const chapterSwiper = new Swiper('.js-chapter-' + videoID, {
        effect: 'slide', // slide,fade,cube,coverflow
        speed: 500, // アニメ速度
        slidesPerView: 'auto', //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
        navigation: {
          nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
          prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
        },
      })
    }
  }

  // チャプター移動
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-chapter')) {
      return
    }

    const target = e.target.dataset.target // 対象のビデオID

    // フルスクリーン用UIを閉じる
    document.querySelector('.js-chapterOpen--' + target).classList.remove('active')
    document.querySelector('.js-chapterOpen-box--' + target).classList.remove('active')

    // チャプター移動して再生開始
    const sec = e.target.value
    player[target].currentTime(sec)
    player[target].play()
  })

  /*
秒数をhh:mm:ss形式に直す
*/
  function sec2hms(sec) {
    const hours = Math.floor(sec / 3600)
    const minutes = Math.floor((sec % 3600) / 60)
    const remainingSeconds = Math.floor(sec % 60)

    // 2桁表示にフォーマットするための補完
    function pad(number) {
      return String(number).padStart(2, '0')
    }

    return pad(hours) + ':' + pad(minutes) + ':' + pad(remainingSeconds)
  }

  //  #####   ######  ##     ##             ####   #####   #####    ######
  //  ##  ##    ##    ####   ##            ##     ##   ##  ##  ##     ##
  //  #####     ##    ##  ## ##  ########   ###   ##   ##  #####      ##
  //  ##  ##    ##    ##    ###               ##  ##   ##  ##  ##     ##
  //  #####     ##    ##     ##            ####    #####   ##   ##    ##

  function barBtnSort(videoID) {
    const video = document.querySelector('.video-' + videoID) // 設置先

    // チャプター→画質→速度の順になるよう配置し直す
    const theatreBtn = video.querySelector('#videoTheatre-' + videoID + '-box')
    const chapterBtn = video.querySelector('#videoChapterFull-' + videoID)
    const cuaBtn = video.querySelector('.vjs-quality-selector')
    const rateBtn = video.querySelector('#videoSpeed-' + videoID + '-box')

    const moreMenu = video.querySelector('#videoMore-' + videoID + '-box')
    const fullScreenBtn = video.querySelector('.vjs-fullscreen-control')
    const pipBtn = video.querySelector('.vjs-picture-in-picture-control')
    const moveList = video.querySelector('#videoMove-' + videoID + '-box')

    const spChapterSlide = video.querySelector('.js-chapterOpen-box--' + videoID)

    // セパレーター
    const sep = video.querySelector('.vjs-spacer')

    // ホバーメニュー右上
    const hoverMenuRightTop = video.querySelector('#hoverMenu-rightTop')

    if (window.matchMedia('(min-width:901px)').matches) {
      //PC
      if (moreMenu) {
        sep.parentNode.insertBefore(moreMenu, sep.nextSibling) // 要素の直後に追加
      }
      if (theatreBtn) {
        sep.parentNode.insertBefore(theatreBtn, sep.nextSibling) // 要素の直後に追加
      }
      if (rateBtn) {
        sep.parentNode.insertBefore(rateBtn, sep.nextSibling) // 要素の直後に追加
      }
      if (cuaBtn) {
        sep.parentNode.insertBefore(cuaBtn, sep.nextSibling) // 要素の直後に追加
      }
      if (fullScreenBtn && moreMenu) {
        sep.parentNode.insertBefore(moreMenu, fullScreenBtn.nextSibling) // 要素の直後に追加
      }
    } else {
      //SP
      if (moreMenu) {
        sep.parentNode.insertBefore(moreMenu, sep.nextSibling) // 要素の直後に追加
      }
      if (fullScreenBtn) {
        sep.parentNode.insertBefore(fullScreenBtn, sep.nextSibling) // 要素の直後に追加
      }
      if (pipBtn) {
        sep.parentNode.insertBefore(pipBtn, sep.nextSibling) // 要素の直後に追加
      }
      if (rateBtn) {
        sep.parentNode.insertBefore(rateBtn, sep.nextSibling) // 要素の直後に追加
      }

      if (moveList && moreMenu) {
        sep.parentNode.insertBefore(moveList, moreMenu.nextSibling) // 要素の直後に追加
      }

      // hoverMenuRightTop.appendChild(rateBtn) // 最後の子要素として追加
      if (cuaBtn && false) {
        //一旦無効
        hoverMenuRightTop.appendChild(cuaBtn) // 最後の子要素として追加
      }
    }

    if (chapterBtn) {
      sep.parentNode.insertBefore(chapterBtn, sep.nextSibling) // 要素の直後に追加
    }
  }

  //  ##   ##   #####   ##   ##  #####  #####
  //  ##   ##  ##   ##  ##   ##  ##     ##  ##
  //  #######  ##   ##  ##   ##  #####  #####
  //  ##   ##  ##   ##   ## ##   ##     ##  ##
  //  ##   ##   #####     ###    #####  ##   ##
  let hoverTimer = null
  window.addEventListener('mousemove', function (e) {
    const item = e.target.closest('.video-js')
    if (!item) {
      return
    }
    clearTimeout(hoverTimer)
    item.classList.add('videoHover')
    hoverTimer = setTimeout(() => {
      item.classList.remove('videoHover')
    }, 3000)
  })
  window.addEventListener('click', function (e) {
    const item = e.target.closest('.video-js')
    if (!item) {
      return
    }
    clearTimeout(hoverTimer)
    item.classList.add('videoHover')
    hoverTimer = setTimeout(() => {
      item.classList.remove('videoHover')
    }, 3000)
  })
  window.addEventListener('mouseout', function (e) {
    const item = e.target.closest('.video-js')
    if (!item) {
      return
    }

    clearTimeout(hoverTimer)
    hoverTimer = setTimeout(() => {
      item.classList.remove('videoHover')
    }, 100)
  })

  //  ##   ##  ##            ##   ##   #####   ##   ##  #####  #####
  //  ##   ##  ##            ##   ##  ##   ##  ##   ##  ##     ##  ##
  //  ##   ##  ##  ########  #######  ##   ##  ##   ##  #####  #####
  //  ##   ##  ##            ##   ##  ##   ##   ## ##   ##     ##  ##
  //   #####   ##            ##   ##   #####     ###    #####  ##   ##
  let uiTimer = null
  // UIホバー中はオーバーレイを出さない
  window.addEventListener('mousemove', function (e) {
    if (!e.target.closest('.vjs-control-bar')) {
      return
    }

    clearTimeout(uiTimer)

    e.target.closest('.js-video').classList.add('uiHover')

    uiTimer = setTimeout(() => {
      e.target.closest('.js-video').classList.remove('hover')
      e.target.closest('.js-video').classList.remove('uiHover')
    }, 5000)
  })
  window.addEventListener('click', function (e) {
    if (!e.target.closest('.vjs-control-bar')) {
      return
    }

    clearTimeout(uiTimer)

    e.target.closest('.js-video').classList.add('uiHover')

    uiTimer = setTimeout(() => {
      e.target.closest('.js-video').classList.remove('hover')
      e.target.closest('.js-video').classList.remove('uiHover')
    }, 5000)
  })
  window.addEventListener('mouseout', function (e) {
    if (!e.target.closest('.vjs-control-bar')) {
      return
    }

    clearTimeout(uiTimer)
    uiTimer = setTimeout(() => {
      e.target.closest('.js-video').classList.remove('hover')
      e.target.closest('.js-video').classList.remove('uiHover')
    }, 100)
  })

  //    ###     ####  ######  ##   #####   ##     ##
  //   ## ##   ##       ##    ##  ##   ##  ####   ##
  //  ##   ##  ##       ##    ##  ##   ##  ##  ## ##
  //  #######  ##       ##    ##  ##   ##  ##    ###
  //  ##   ##   ####    ##    ##   #####   ##     ##
  //            #####     ###    ##   ##   ####  #####
  //            ##  ##   ## ##   ##   ##  ##     ##
  //  ########  #####   ##   ##  ##   ##   ###   #####
  //            ##      #######  ##   ##     ##  ##
  //            ##      ##   ##   #####   ####   #####

  // すべての動画オブジェクトを止める
  function allPause() {
    for (const iterator of player) {
      if (!iterator) {
        continue
      }
      iterator.pause()
    }
  }
}

function initMobileQualityMenu(videoID) {
  // 画面≤768px の場合、画質メニューをタップで開閉できるようにする
  // if (!window.matchMedia('(max-width: 768px)').matches) return

  const quality = document.querySelector('.video-' + videoID + ' .vjs-quality-selector')
  if (!quality) return
  const vjsMenu = quality.querySelector('.video-' + videoID + ' .vjs-menu')
  if (!vjsMenu) return

  const subItems = vjsMenu.querySelectorAll('.vjs-menu-item')

  // 表示/非表示が切り替わります
  quality.addEventListener('click', function (e) {
    // 子要素 (メニュー項目) をクリックした場合は、スキップします。
    if (e.target.closest('.vjs-menu-item')) return

    vjsMenu.classList.toggle('active')
  })

  // 項目を選択するとメニューが非表示になります
  subItems.forEach((item) => {
    item.addEventListener('click', function (e) {
      e.stopPropagation()
      vjsMenu.classList.remove('active')
    })
  })
}

// 速度メニュー外をクリックしたらメニューを閉じる
document.addEventListener('click', function (e) {
  const speedBox = document.querySelector('.videoSpeed.hover')
  if (speedBox && !e.target.closest('.videoSpeed')) {
    speedBox.classList.remove('hover')
  }
})
